import type { ChainNetwork } from '@ducat-unit/core';

import type { WalletType } from './types';

export interface WalletAccountTuple {
  funds: { address: string; pubkey: string };
  asset: { address: string; pubkey: string };
  vault: { address: string; pubkey: string };
}

export interface WalletAccountSnapshot extends WalletAccountTuple {
  network: ChainNetwork;
  walletType: WalletType;
}

export interface AccountPublication {
  invalidated: boolean;
  revision: number;
  token: number;
}

export function createWalletAccountSnapshot(params: {
  account: WalletAccountTuple;
  network: ChainNetwork;
  walletType: WalletType;
}): WalletAccountSnapshot {
  const { account, network, walletType } = params;
  return {
    network,
    walletType,
    funds: { address: account.funds.address, pubkey: account.funds.pubkey },
    asset: { address: account.asset.address, pubkey: account.asset.pubkey },
    vault: { address: account.vault.address, pubkey: account.vault.pubkey },
  };
}

export function walletAccountSnapshotsEqual(left: WalletAccountSnapshot | null, right: WalletAccountSnapshot | null): boolean {
  if (left === right) return true;
  if (!left || !right) return false;

  return (
    left.network === right.network &&
    left.walletType === right.walletType &&
    left.funds.address === right.funds.address &&
    left.funds.pubkey === right.funds.pubkey &&
    left.asset.address === right.asset.address &&
    left.asset.pubkey === right.asset.pubkey &&
    left.vault.address === right.vault.address &&
    left.vault.pubkey === right.vault.pubkey
  );
}
